import React, { useState , useEffect}  from 'react'
import SearchMaquinas from '../../components/Search/SearchMaquinas';
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import { useStateContext } from '../../contexts/ContextProvider';
import { crearMensaje, notificarUsuario } from '../../services/Util';
import { getMensajeRol } from '../../services/UsuarioSucursal';
import {Toaster, toast } from 'react-hot-toast';
import { crearTicket } from '../../services/Tikets';
import { marcarSalidaObraCarpeta } from '../../services/Carpetas';
import { fetchUser } from '../../utils/fetchUser';
import { formatDate } from '../../formatters/date';

const initialState = {
  _id: null,
  empresa: null,
  codigo: '',
  nombreEquipo: '',
  marca: '',
  modelo: '',
  serie: '',
  patente: '',
  estado: 'Activo',
  };

const SalidaObra = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [selectedDateObra, setSelectedDateObra] = useState(getFirstDayOfMonth('Nada')); // Fecha inicial getFirstDayOfMonth('Fin')
  const [observacion, setObservacion] = useState('');
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const userInfo = fetchUser();

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  const handleDateObraChange = (date) => {
    setSelectedDateObra(date);
  };

  const handleChangeObs = (obs) => {
    setObservacion(obs);
  };

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const camposRequeridos = [
      'codigo',
      'marca',
      'modelo',
      'serie',
      'patente'
    ];

    for (const campo of camposRequeridos) {
      if (!formData[campo]) {
        toast.error('Debe seleccionar un equipo.');
        return;
      }
    }

    if (!selectedDateObra){
      toast.error('Debe seleccionar una fecha de entrega.');
      return;
    }

    const fecha = formatDate(selectedDateObra)

    const dataBase = {
      empresa: userInfo.empresa,
      tipo: 'Logística',
      numTicket: 0, // Número secuencial
      requerimiento: 'Salida de Obra ' + formData.codigo,
      observacion: 'Equipo sale de obra ' + formData.codigo,
      documentosRespaldo: [],
      fechaEntrega: null,
      numOT:'',
      fechaCreacion: new Date().toISOString(),
      idCreador: userInfo.usuario,
      idAsignado: null,
      estado: 'Pendiente',
    };

    const miTicket = await crearTicket( dataBase );

    await marcarSalidaObraCarpeta(formData.codigo);

    const mUser = await getMensajeRol('Logística');
    const dataMensaje = {
    numTicket: miTicket.numTicket,
    codigo: formData.codigo,
    serie: formData.serie,
    patente: formData.patente,
    fechaEntrega: fecha,
    };
    if (mUser){
      mUser.forEach(element => {     
        let mensaje = crearMensaje(element._id, 'salidaObra', dataMensaje);
        notificarUsuario(JSON.stringify(mensaje));
      });
    }

    toast.success('Ticket de Salida de Obra creado correctamente. Número de Ticket: ' + miTicket.numTicket);

    setFormData(initialState);
    setSelectedDateObra( getFirstDayOfMonth('Nada') );
    setObservacion('');
  };

  return (
    <>
    <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">


    <div className="container mx-auto p-2 md:p-2">

    <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
                  <p className="text-gray-800 font-semibold text-base md:text-lg">
                  Salida de Obra
                  </p>
                </div>
              </div>
     
      
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-2">
            <div className="md:col-span-3 bg-white p-6 rounded-lg shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                    <div className="flex flex-col ">
                      <SearchMaquinas
                        estado='Asignado'
                        onValorSeleccionadoChange={(docSeleccionado) => {
                          if (!docSeleccionado) return;
                          setFormData({
                            _id: docSeleccionado._id, 
                            empresa: docSeleccionado.empresa,
                            codigo: docSeleccionado.codigo,
                            nombreEquipo: docSeleccionado.nombreEquipo,
                            marca: docSeleccionado.marca,
                            modelo: docSeleccionado.modelo,
                            serie: docSeleccionado.serie,
                            patente: docSeleccionado.patente,
                            estado: docSeleccionado.estado,
                          })
                          
                        }}
                      />
                    </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2" >        
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Equipo</label>
                      <input
                        type="text"
                        className={inputClass}
                        name="codigo"
                        disabled
                        value={formData.codigo}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-span-2">
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Descripción</label>
                      <input
                        type="text"
                        className={inputClass}
                        name="nombreEquipo"
                        disabled
                        value={formData.nombreEquipo}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2" > 
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Modelo</label>
                      <input
                        type="text"
                        className={inputClass}
                        name="modelo"
                        disabled
                        value={formData.modelo}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Marca</label>
                      <input
                        type="text"
                        className={inputClass}
                        name="marca"
                        disabled
                        value={formData.marca}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Serie</label>
                      <input
                        type="text"
                        className={inputClass}
                        name="serie"
                        disabled
                        value={formData.serie}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Patente</label>
                      <input
                        type="text"
                        className={inputClass}
                        name="patente"
                        disabled
                        value={formData.patente}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col">
                        <p className="text-xs text-gray-600"> Estado </p>
                        <select className={inputClass} name="estado" value= {formData.estado} disbled onChange={handleChange}>
                            <option value="ACTIVO">Activo</option>
                            <option value="Asignado">Asignado</option>
                            <option value="INACTIVO">Inactivo</option>
                            <option value="ELIMINADO">Eliminado</option>
                        </select>
                    </div>
               </div>               
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Fecha Entrega</label>
                      <SeleccionaFecha
                        selectedDate={selectedDateObra}
                        handleDateChange={handleDateObraChange}
                      />
                </div>
                <div className="flex flex-col ">
                  <label className="text-xs font-semibold mb-1">Obs.</label>
                  <textarea
                    type="text"
                    className="text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300 h-20 max-h-30"
                    placeholder=""
                    name="observacion"
                    onChange={handleChangeObs}
                  />
                </div>
                <div className="flex flex-col ">
                    <button
                        onClick={handleSubmit}
                        className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                    >
                    Informar
                    </button>
                </div>
            </div>
        </div>
    </div>


</div>

<Toaster
  position="top-right"
  toastOptions={{
    style: {
      zIndex: 9999,
    },
  }}
/>  
</>
  )
}

export default SalidaObra